// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeKingston__contentWrap__MqdC-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeKingston/ConsentTypeKingston.css
// module id = 1445
// module chunks = 0